import styled from "styled-components";
import { lighten, darken } from "polished";
import theme from "../style/theme";

const $disabled1 = darken(0.14, theme.c.light);
const $disabled2 = lighten(0.18, theme.c.pale);
const $disabled3 = darken(0.1, theme.c.pale);

export const Icon = styled.div`
    background-color: ${$disabled2};
    border: 4px solid ${$disabled1};
    transition: 300ms;
    .color-1-fill {
        fill: ${$disabled1};
    }

    .color-2-stroke {
        stroke: ${$disabled3};
    }

    .color-2-fill {
        fill: ${$disabled3};
    }
    display: inline-block;
    border-radius: 50px;
    overflow: hidden;
    flex-shrink: 0;

    svg {
        display: block;
        * {
            transition: 300ms;
        }
    }

    &.ActiveIcon {
        background-color: ${theme.c.active};
        border: 4px solid ${theme.c.boost};
        .color-1-fill {
            fill: ${theme.c.info};
        }

        .color-2-stroke {
            stroke: ${theme.c.black};
        }

        .color-2-fill {
            fill: ${theme.c.black};
        }
    }

    &.CompletedIcon {
        background-color: ${theme.c.info};
        border: 4px solid ${darken(0.1, theme.c.info)};
        .color-1-fill {
            fill: ${lighten(0.3, theme.c.info)};
        }

        .color-2-stroke {
            stroke: ${darken(0.2, theme.c.info)};
        }

        .color-2-fill {
            fill: ${darken(0.2, theme.c.info)};
        }
    }
`;